export const REGION_COOKIE_KEY = 'region';
